<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t('notificationslog') }}</div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>

      <div v-if="Notifications.length > 0" class="d-flex align-items-center">
        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
            >{{list.name}}</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th v-if="userId == 1" class="text-center">{{ $tc('user',1) }} {{ $t('name') }}</th>
            <th class="text-center">{{ $t('notificationtitle') }}</th>
            <th class="text-center">{{ $t('notificationsmsg') }}</th>
            <th class="text-center">{{ $t('notificationstype') }}</th>
            <th class="text-center">{{ $t('notificationread') }}</th>
            <th class="text-center">{{ $t('createdat') }}</th>
            <th class="text-center">{{ $t('modifiedat') }}</th>
          </tr>
        </thead>
        <tbody v-if="Notifications.length > 0">
          <tr
            v-for="(notificationList, notificationListIndex) in Notifications"
            :key="notificationListIndex"
          >
            <td
              v-if="userId == 1"
              class="text-center"
            >{{ notificationList.first_name }} {{ notificationList.middle_name }} {{ notificationList.last_name }}</td>
            <td class="text-center">{{ notificationList.notification_title }}</td>
            <td class="text-center">{{ notificationList.notification_msg }}</td>
            <td class="text-center">{{ notificationList.notification_type }}</td>
            <td v-if="notificationList.is_read == 'Y'" class="text-center">Yes</td>
            <td v-else class="text-center">
              <strong>No</strong>
            </td>
            <td class="text-center">{{ notificationList.nl_created_at | fulldateparse }}</td>
            <td class="text-center">{{ notificationList.nl_updated_at | fulldateparse }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="7">
              <!-- {{ $tc('noNotificationlogsFound') }} -->
            <NoRecords/>
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-if="Notifications.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue"

export default {
  components:{
    NoRecords
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      // rows: 0,
      selectedvalue: "10",

      viewingnumbers: [],
      emailreoprtList: []
    };
  },
  computed: {
    userId() {
      return this.secureStore.get("USINFO").user_id;
    },
    Notifications() {
      // return this.$store.getters.NoificationList;
      return 0;
    },
    rows() {
      return this.$store.getters.RowsCount;
    }
  },
  beforeMount() {},
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.GetNotifications();
      } else {
        this.currentPage = event;
        this.GetNotifications();
      }
    },
    GetNotifications: function() {
      this.$store.dispatch("GetNotifications", {
        user_id: this.userId,
        limit: this.perPage,
        currentPage: this.currentPage
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/UserManagement/NotificationLogComponents/listnotificationlogs.vue